import { AuthState } from '@okta/okta-auth-js';
import axios from 'axios';
import BaseService from './baseService';

export interface FileContentResponse {
    content: any;
}

export interface FileContentParams {
    content: {
        components?:{
            schemas?:{
                [schema: string]: {
                    description?: string; // Optional description for the schema
                    properties?: {
                        [propertyName: string]: {
                            ref?: string; // Optional reference to another schema
                            message?: string; // Optional message for the property
                            description?:string;
                            example?: string;
                            type?: string; // Type of the property (e.g., string, number, object)
                            state?: string[]; // Optional state of the property
                        }
                    }
                    required?: string[]; // Optional array of required properties
                    type?: string; // Optional type of the schema
                }
            }
        }
        info?:{
            title?: string; // Optional title for the API
        }
        paths:{
            [path: string]: {
                [method: string]: {
                    description?: string; // Optional description for the method
                    operationId?: string; // Optional operation ID
                    parameters?: {
                        name: string; // Name of the parameter
                        in: string; // Location of the parameter (e.g., query, header)
                        required?: boolean; // Optional flag indicating if the parameter is required
                        schema?: {
                            type?: string; // Optional type of the parameter
                            format?: string; // Optional format of the parameter
                        }
                    }[];
                    responses?: {
                        [statusCode: string]: {
                            description?: string; // Optional description for the response
                            summary?: string; // Optional summary for the response
                            content?: {
                                [mediaType: string]: {
                                    schema?: {
                                        $ref?: string; // Reference to a schema definition
                                        responseSchema?: string[]; // Optional response schema
                                    }
                                }
                            }
                        }
                    }
                }

            }

        }
        openApi?: string; // Optional OpenAPI version
        fileName?: string; // Optional file name
        file?: string; // Optional file path
    }
}

export default class DetailService extends BaseService {
    constructor() {
        super();
    }

    public async fetchFileContent(sourceUrl: string, apiId: string, authState: AuthState | null): Promise<FileContentResponse> {
        const url = `${this.REACT_APP_API_BASE_URL}/uri/fetch-file-content`;
        //console.log(`URL for fetching file content: ${url}`);
        //console.log(`Parameters - sourceUrl: ${sourceUrl}, apiId: ${apiId}`);
        //console.log(`AuthState available: ${!!authState}`);
        
        const headers = this.getHeaders(authState).headers; // Extract just the headers object
        //console.log('Headers being sent:', headers);
        
        const params = { sourceUrl, apiId };
        
        try {
            const response = await axios.get<FileContentResponse>(url, { 
                params, 
                headers
            });
            //console.log(`Successfully fetched file content for API ID: ${apiId}`);
            //console.log(`Response data:`, response.data);
            const content = response.data.content;
            //console.log(`Response data:`, content);
            return content;

        } catch (error) {
            console.log(`Error fetching file content for API ID: ${apiId} from URL: ${sourceUrl}`);
            console.log('Headers that were sent:', headers);
            console.error(`Error details:`, error);
            throw new Error('Failed to fetch file content');
        }
    }

    public async getApiSpecData(responseData: FileContentParams): Promise<any> {
        //console.log("The response data received: ", responseData.content);
        if (!responseData) {
            throw new Error('No API specification available');
        }
        
        try {
            const fileName = responseData.content?.fileName || 'URL is not provided';
            const title = responseData.content.info?.title || 'No title provided';
            const paths = responseData.content.paths || {};
            const components = responseData.content.components || {};
            const schemas = responseData.content.components?.schemas || {};
            
            //console.log(`Title: ${title}`);
            //console.log(`Available paths: ${Object.keys(paths)}`);
            //console.log(`Available components: ${Object.keys(components)}`);
            //console.log(`Available schemas: ${Object.keys(schemas)}`);
            //console.log('Schema details:', JSON.stringify(schemas, null, 2));
            //console.log('Full responseData.content structure:', JSON.stringify(responseData.content, null, 2));

            return {
                fileName,
                title,
                paths,
                components: {
                    schemas
                },
                totalPaths: Object.keys(paths).length,
                totalSchemas: Object.keys(schemas).length
            };
        } catch (error) {
            console.error('Error processing API spec data:', error);
            throw new Error('Failed to process API spec data');
        }
    }
}